import type { NonNullableFormBuilder } from '@angular/forms';
import type { Except } from 'type-fest';
import { BusinessHoursFormComponent } from '../../../../../common/components/forms/business-hours-form/business-hours-form.component';
import { InformationFormComponent } from '../../../../../common/components/forms/information-form/information-form.component';
import { NoteFormComponent } from '../../../../../common/components/forms/note-form/note-form.component';
import { PhoneFormComponent } from '../../../../../common/components/forms/phone-form/phone-form.component';
import { PointOfInterestAssignedContractorsFormComponent } from '../../point-of-interest-form/point-of-interest-assigned-contractors-form/point-of-interest-assigned-contractors-form.component';
import { PointOfInterestTimesFormComponent } from '../../point-of-interest-form/point-of-interest-times-form/point-of-interest-times-form.component';
import type { PointOfInterest } from '../interfaces/point-of-interest';

type PointOfInterestFormGroup = ReturnType<
  typeof PointOfInterestFormHelper.buildForm
>;
export type PointOfInterestForm = ReturnType<
  PointOfInterestFormGroup['getRawValue']
>;

export interface PointOfInterestFormDto {
  name: PointOfInterestForm['pointInformation']['name'];
  address: PointOfInterestForm['pointInformation']['address'];
  businessHours: PointOfInterestForm['businessHours'];
  time: PointOfInterestForm['times'];
  phone: PointOfInterestForm['contact']['phone'];
  note: PointOfInterestForm['note'];
  contractors: Except<
    PointOfInterestForm['contractor']['contractors'][number],
    'contractor'
  >[];
}

export class PointOfInterestFormHelper {
  public static fromDto(dto: PointOfInterest): PointOfInterestForm {
    return {
      ...dto,
      pointInformation: {
        address: dto.address,
        name: dto.name,
      },
      times: {
        averageServiceTime: dto.time.averageServiceTime,
      },
      contact: { phone: dto.phone },
      contractor: {
        selectedContractors: dto.contractors.map(
          (contractor) => contractor.contractor.uuid,
        ),
        contractors: dto.contractors.map((contractor) => ({
          contractor: contractor.contractor,
          gate: contractor.gate,
          uuid: contractor.contractor.uuid,
        })),
      },
      note: {
        content: dto.note?.content ?? null,
      },
    };
  }

  public static buildForm(fb: NonNullableFormBuilder) {
    return fb.group({
      pointInformation: InformationFormComponent.buildForm(fb),
      businessHours: BusinessHoursFormComponent.buildForm(fb),
      times: PointOfInterestTimesFormComponent.buildForm(fb),
      contact: PhoneFormComponent.buildForm(fb, true),
      note: NoteFormComponent.buildForm(fb),
      contractor: PointOfInterestAssignedContractorsFormComponent.buildForm(fb),
    });
  }
}
